export enum RESPONSE_MODAL_VARIANTS {
  SUCCESS = "SUCESS",
  WARNING = "WARNING",
  ERROR = "ERROR"
}